import {ColorUtils} from '@/model/project/utils/colorutils'
import { LineColorProperty } from "./properties/linecolorproperty";
import { FillColorProperty } from "./properties/fillcolorproperty";
import { FillingProperty } from "./properties/fillingproperty";
import Konva from "konva";
import { Rectangle } from "./rectangle";

export class Cylinder extends Rectangle{
   

    public drawObject():void{
		super.initObject();

		let color:string = this.color;
		const lineprop = this.properties==null?null:this.properties['linecolor'];
		if (lineprop!=null){	
			const linecolorproperty:LineColorProperty =Object.assign(new LineColorProperty(), lineprop);
			if (linecolorproperty!=null) 
					color = linecolorproperty.getColor(this.tagnames, this.color)
			
		}	
		let fillcolor = '0xffffff00';
        if (this.fill){
                let fillheight = this.height
                const fillingprop = this.properties==null?null:this.properties['filling']
                if (fillingprop != null){
                    const fillingproperty:FillingProperty =Object.assign(new FillingProperty(), fillingprop);
                    fillheight = fillingproperty.getHeight(this.tagnames, this.height)
                 }
            fillcolor = this.fillcolor;
            const fillprop = this.properties==null?null:this.properties['fillcolor'];
            if (fillprop!=null){	
                const fillcolorproperty:FillColorProperty =Object.assign(new FillColorProperty(), fillprop);
                if (fillcolorproperty!=null) 
                        fillcolor = fillcolorproperty.getColor(this.tagnames, this.fillcolor)     
            }	
            const fillcolor2 = ColorUtils.convertformat(fillcolor)
            const rectfill = new Konva.Rect({
                x: 0,
                y: this.height - fillheight,
                width: this.width,
                height: fillheight,
                //fill: ColorUtils.convertformat(fillcolor),
              });
              rectfill.fillLinearGradientStartPoint({ x: 0, y: this.height });
              rectfill.fillLinearGradientEndPoint({ x: this.width, y: this.height });
              rectfill.fillLinearGradientColorStops([0, fillcolor2, 0.5, 'white', 1, fillcolor2])
              this.node.add(rectfill)
        }    
		const rect = new Konva.Rect({
            x: this.linewidth/2,
            y: this.linewidth/2,
            width: this.width-this.linewidth,
            height: this.height-this.linewidth,
            stroke: ColorUtils.convertformat(color),
            strokeWidth: this.linewidth,
          });

          this.node.add(rect)
    }
}